import React from 'react';
import { GTMProvider } from '@elgorditosalsero/react-gtm-hook';
import type { AppProps } from 'next/app';

// 用于谷歌gtm ；在需要使用的page使用，传入包裹页面，传入state（gtmId）；
const withGTM = (Component: React.VFC<any> | AppProps['Component'], GTMState: any) => (props: any) => {
  return (
    <GTMProvider state={GTMState}>
      <Component {...props} />
    </GTMProvider>
  );
};
export default withGTM;
